class BigVideo extends HTMLElement {
  constructor() {
    super();
    this.modal = null;
    this.modalVideo = null;
    this.controller = new AbortController();
  }

  connectedCallback() {
    this.modal = this.querySelector('[data-modal]');
    this.modalVideo = this.querySelector('[data-modal-video]');

    if (!this.modal || !this.modalVideo) return;

    this.querySelectorAll('[data-modal-trigger]').forEach((trigger) => {
      trigger.addEventListener('click', this.openModal, {
        signal: this.controller.signal,
      });
    });

    this.querySelectorAll('[data-modal-close]').forEach((closer) => {
      closer.addEventListener('click', this.closeModal, {
        signal: this.controller.signal,
      });
    });

    // Prevent clicks on the video from closing the modal
    this.querySelector('[data-modal-content]')?.addEventListener(
      'click',
      (e) => {
        e.stopPropagation();
      },
      { signal: this.controller.signal }
    );

    document.addEventListener(
      'keydown',
      (e) => {
        if (e.key === 'Escape' && !this.modal.classList.contains('hidden'))
          this.closeModal();
      },
      { signal: this.controller.signal }
    );
  }

  disconnectedCallback() {
    this.closeModal();
    this.controller.abort();
  }

  openModal = () => {
    this.modal.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
    this.modalVideo.play().catch(() => {});
  };

  closeModal = () => {
    this.modal.classList.add('hidden');
    document.body.style.overflow = '';
    this.modalVideo.pause();
    this.modalVideo.currentTime = 0;
  };
}

if (!customElements.get('big-video')) {
  customElements.define('big-video', BigVideo);
}
